import React from 'react';
import Form from '../Form';
import Checkbox from '../../atoms/Checkbox';
import { SummaryFilterType } from '../../../Common';

export interface SummaryFilterTypeProps {
  listItem: { [key: string]: SummaryFilterType };
  title: string;
  listChecked: string[];
  setListChecked: React.Dispatch<React.SetStateAction<string[]>>;
  type: string;
}

const SummaryFilterTypeComp: React.FC<SummaryFilterTypeProps> = ({ listItem, title, listChecked, setListChecked, type }) => {
  const onCheckedAll = () => {
    const listSummaryFilterTypes = Object.keys(listItem);
    if (listChecked.length === listSummaryFilterTypes.length) {
      setListChecked([]);
    } else {
      setListChecked(listSummaryFilterTypes);
    }
  };

  const onChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>, code: string) => {
    const ischecked = e.target.checked;
    let listCheckedTmp = [...listChecked];
    if (ischecked) {
      listCheckedTmp.push(code);
    } else {
      listCheckedTmp = listCheckedTmp.filter((item) => item !== code);
    }

    setListChecked(listCheckedTmp);
  };

  const displayListItem = Object.values(listItem).sort((a, b) => {
    // displayOrderが付与されている場合は並べ替え
    if (!a.displayOrder || !b.displayOrder) return 0;
    return a.displayOrder < b.displayOrder ? -1 : 1;
  });

  return (
    <div className='uc-form-field u-mt24'>
      <div className='uc-form-field__label u-flex'>
        <span data-testid={`title-checkbox-list-${type}`} data-testid-e2e={`title-checkbox-list-${type}`}>
          {title}
        </span>
        <span
          data-testid={`btn-checkbox-all-${type}`}
          data-testid-e2e={`btn-checkbox-all-${type}`}
          className='u-ml8'
          style={{ color: '#5084d4', cursor: 'pointer' }}
          onClick={onCheckedAll}>
          一括選択
        </span>
      </div>
      <div className='uc-form-field__control'>
        <Form>
          <Form.Fileld labelFor='templateSelect'>
            <ul className='list'>
              {displayListItem.map(({ label, code }: SummaryFilterType) => {
                return (
                  <li key={`${type}-${code}`} data-testid={`checkboxs-list-${type}`} data-testid-e2e={`checkboxs-list-${type}`}>
                    <Checkbox
                      data-testid={`checkbox-item-${type}-${code}`}
                      data-testid-e2e={`checkbox-item-${type}-${code}`}
                      className='u-ml'
                      labelClassName='u-mv8 u-h-auto'
                      label={label}
                      onChange={(e) => onChangeCheckbox(e, code)}
                      checked={listChecked.includes(code)}
                    />
                  </li>
                );
              })}
            </ul>
          </Form.Fileld>
        </Form>
      </div>
    </div>
  );
};

export default SummaryFilterTypeComp;
